export enum ArchiveSourceDTO {
  /** Archived created based on {@link ClosSession} */
  session = 'standard',

  /** Archived created based on file sharing */
  sharing = 'share_file',
}

export enum ArchiveStatusDTO {
  created = 'created',
}

export interface ArchiveDTO {
  _id: string;
  name: string;
  type: ArchiveSourceDTO;
  status: ArchiveStatusDTO;
  owner_id: string;
  owner_name: string;
  photograph_id: string;
  model_ids: string[];
  participants: string[];
  logo: string;
  logo_name: string;
  date: string;
  image_uploaded_count: number;
  image_count: number;
  /** images uploaded as sharing attachments */
  retouch_image_count: number;
  dropbox_image_count: number;
  local_image_count: number;
  inner_gallery_images_count: number;
  video_count: number;
  is_owner: boolean;
  archive_link: string;
  payment_link: string;
  is_paid_owner: boolean;
  is_prices_created: boolean;
  is_available_for_all: boolean;
  /** user avatars, not the archive */
  avatars: {
    [userId: string]: string;
  };
  users: {
    [userId: string]: ArchiveUserDTO;
  };
  buttons: ArchiveButtonDTO[];
  album_price?: number; // in cents
  photo_price?: number; // in cents
  expire_at?: string;
}

export interface CreateArchiveDTO {
  _id: string;
  name: string;
  type: ArchiveSourceDTO;
  owner_id: string;
  owner_name: string;
  photograph_id: string;
  model_id: string;
  participants: string[];
  status: ArchiveStatusDTO;
  token: string;
  links_by_role: {
    observer: string;
  };
  link: string;
  deeplink: string;
  is_cloud_images: boolean;
  is_available_for_all: boolean;
  clos_cloud_images_count: number;
  dropbox_images_count: number;
  local_images_count: number;
  inner_gallery_images_count: number;
  is_paid_owner: boolean;
  avatars: null;
  users: null;
}

export interface ArchiveUserDTO {
  _id: string;
  name: string;
  avatar: string;
}

export interface ArchiveButtonDTO {
  name: string;
  disabled: boolean;
}
